export enum FavoriteStoreErrors {
    CustomerNotFound = 'customerNotFound',
    Default = 'defaultError',
}
